import {
  Select,
  Typography,
  MenuItem,
} from '@mui/material';
import ButtonWithSpinner from '../../../../../components/buttons/ButtonWithSpinner';
import TooltipWithIndicator from '../../../../../components/tooltip/TooltipWithIndicator';
import './SelectorForm.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  options: [],
  tooltip: null,
  loading: false,
  value: null,
  handleOnChange: () => { },
  handleOnClick: () => { },
  dataTest: '',
};
const SelectorForm = (p) => {
  const {
    label,
    options,
    tooltip,
    loading,
    value,
    handleOnChange,
    handleOnClick,
    dataTest,
  } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <div className='selector-form' data-test={`selector-form-${dataTest}`}>
      <div className='label-container' data-test={`label-container-${dataTest}`}>
        <Typography variant='subtitle1' className='label' data-test={`label-${dataTest}`}>
          {label}
        </Typography>
        {tooltip ? (
          <TooltipWithIndicator className='tooltip' {...tooltip} />
        ) : null}
      </div>
      <Select
        value={value === null || value === undefined ? '' : value}
        variant='outlined'
        fullWidth
        onChange={handleOnChange}
        data-test={`selector-${dataTest}`}
        inputProps={{
          'aria-label': label,
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.key} value={option.value} data-test={`selector-value-${dataTest}-${option.key}`}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
      <ButtonWithSpinner
        loading={loading}
        className='apply-button'
        label='Apply'
        disabled={value === null || value === undefined}
        onClick={handleOnClick}
        data-test={`apply-action-${dataTest}`}
      />
    </div>
  );
};

export default SelectorForm;
